import { render, staticRenderFns } from "./IndexPrice.vue?vue&type=template&id=9703e6ba&scoped=true&"
import script from "./IndexPrice.vue?vue&type=script&lang=js&"
export * from "./IndexPrice.vue?vue&type=script&lang=js&"
import style0 from "./IndexPrice.vue?vue&type=style&index=0&id=9703e6ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9703e6ba",
  null
  
)

export default component.exports